import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthFlowService } from '../services/auth-flow/auth-flow.service';
import { AuthService } from '../common/auth/src/services/auth.service';
import { map, take } from 'rxjs/operators';

/**
 * Guard for auth flow route (path: '')
 * Handles users entering the auth flow
 * - If flow is already completed → redirect to appropriate home page
 * - If flow is not completed → allow access to continue flow
 */
export const authFlowGuard: CanActivateFn = () => {
  const authFlowService = inject(AuthFlowService);
  const authService = inject(AuthService);
  const router = inject(Router);
  
  // Check authentication status from Cognito
  return authService.isAuthenticated$().pipe(
    take(1), // Take only first value to prevent multiple checks
    map((isAuthenticated) => {
      // If authenticated and flow is completed, redirect to appropriate route
      if (isAuthenticated && authFlowService.isCompleted()) {
        const completionRoute = authFlowService.getCompletionRoute();
        
        // Fallback to /home if completionRoute is empty
        const targetRoute = completionRoute && completionRoute.trim() !== '' ? completionRoute : '/home';
        return router.createUrlTree([targetRoute]);
      }
      
      // Otherwise allow access to auth flow (for new users or incomplete flows)
      return true;
    })
  );
};